var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningSemibold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1051 17.2569L13.3001 5.3159C12.7247 4.30616 11.2691 4.30616 10.6937 5.3159L3.88869 17.2569C3.31882 18.2568 4.04096 19.4996 5.19192 19.4996H18.8019C19.9528 19.4996 20.675 18.2568 20.1051 17.2569ZM14.6033 4.57321C13.4525 2.55372 10.5413 2.55372 9.39042 4.57321L2.58546 16.5142C1.44572 18.5141 2.89 20.9996 5.19192 20.9996H18.8019C21.1038 20.9996 22.5481 18.5141 21.4083 16.5142L14.6033 4.57321Z",
    fill: "#C0382C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17Z",
    fill: "#C0382C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 14.75C12.4142 14.75 12.75 14.4142 12.75 14V9.00001C12.75 8.5858 12.4142 8.25001 12 8.25001C11.5858 8.25001 11.25 8.5858 11.25 9.00001V14C11.25 14.4142 11.5858 14.75 12 14.75Z",
    fill: "#C0382C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningSemibold);
export default __webpack_public_path__ + "static/media/warning-semibold.4daeecf18c35414508206df49838a106.svg";
export { ForwardRef as ReactComponent };